import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import config from '@plone/volto/registry';
import HeadTitle from '@package/components/HeadTitle';

const SubjectView = (props) => {
  const { data } = props;

  if (!data?.subjectContent) return null;

  const show_alignment = !config.blocks?.blocksConfig?.subject?.hide_alignment;

  return (
    <HeadTitle
      content={data.subjectContent}
      align={show_alignment ? data.alignment : null}
    />
  );
};

export default withBlockExtensions(SubjectView);
